import type { DriverRankingPeriodStatus } from '@/backend/market'

export class DriverRankingPeriodEntity {
  id?: string
  regionId?: number
  regionName?: string | null
  settingsId?: string
  startDate?: string
  endDate?: string
  status?: DriverRankingPeriodStatus
  calculatedAt?: string | null
  createdAt?: string
  updatedAt?: string
  label?: string
}
